import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_ScheduledJobs } from "../shared/data.service";
import { RecipientRequest } from "../shared/Recipient-request";
import { RiAddRecipientsComponent } from "./ri-add-recipients/ri-add-recipients.component";

@Component({
	selector: "caass-ri-job-recipients-table",
	templateUrl: "./ri-job-recipients-table.component.html",
	styleUrls: ["./ri-job-recipients-table.component.css"],
})
export class RiJobRecipientsTableComponent implements OnInit, OnChanges {
	constructor(private dataService: DataService_ScheduledJobs, private dialogService: DialogService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadUsers();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.loadUsers();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	@Input() SelectedJob: any;

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedUsers: any = [];
	lstUser: any = [];

	lstSchoolFullName: any = [];

	cols: any = [
		{ field: "Username", header: "Username" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "StaffTitle", header: "Title" },
		{ field: "SchoolFullName", header: "Home School" },
	];

	TableLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: any = "";

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////

	loadUsers() {
		this.SelectedUsers = [];

		if (this.SelectedJob == undefined || this.SelectedJob.JobID <= 0) {
			return;
		}

		this.TableLoading = true;

		var result = this.dataService.RecipientSelectList(this.SelectedJob.JobID);
		result.subscribe(
			(response) => {
				this.TableLoading = false;

				this.lstUser = response;

				//Load Data Filter Lists
				this.lstSchoolFullName = Array.from(new Set(this.lstUser.map((item: any) => item.SchoolFullName))).sort();
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////

	onRefresh() {
		this.loadUsers();
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(RiAddRecipientsComponent, {
			header: "Add Recipients",
			width: "fit-content",
			data: {
				JobID: this.SelectedJob.JobID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadUsers();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedJob.CanEdit == false) {
			this.errorMessage = "User does not have permission to delete schedules for this job";
			return;
		}

		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select users to stop sending the report to";
			return;
		}

		this.confirmationService.confirm({
			key: "reportinboxrecipientsconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"Are you sure you want to stop sending the report to " +
				this.SelectedUsers.length +
				" user" +
				(this.SelectedUsers.length == 1 ? "" : "s") +
				"?",
			header: "Confirm Remove",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.Processing = true;

		var lstUID = this.SelectedUsers.map((user) => user.UserID);

		var parms: RecipientRequest = {
			JobID: this.SelectedJob.JobID,
			lstRecipient: lstUID,
		};

		var result = this.dataService.JobRecipientDelete(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "reportinboxrecipients",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Users were removed from the report successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUsers();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "reportinboxrecipients",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not remove users from the report: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onRowSelect(val) {
		this.errorMessage = "";
		// this.SelectedUser = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		// this.SelectedUser = null;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	///////////////////////////////////////////////////////
}
